import { render, staticRenderFns } from "./InputElement.vue?vue&type=template&id=3b022f7d&"
import script from "./InputElement.vue?vue&type=script&lang=js&"
export * from "./InputElement.vue?vue&type=script&lang=js&"
import style0 from "./InputElement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b022f7d')) {
      api.createRecord('3b022f7d', component.options)
    } else {
      api.reload('3b022f7d', component.options)
    }
    module.hot.accept("./InputElement.vue?vue&type=template&id=3b022f7d&", function () {
      api.rerender('3b022f7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Elements/InputElement.vue"
export default component.exports